import api from './api';

const sharedUrl = '/shared';

export function getDownloadLink(amazonKey: string, bucketName?: string) {
  return api.get(`${sharedUrl}/get-download-link/${amazonKey}/${bucketName}`)
    .then((response) => {
    return {
      amazonKey,
      url: response.data.url,
      filename: response.data.filename, // Include the filename in the response
    };
  });
}
